import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
    import.meta.env.VITE_PUBLIC_SUPABASE_URL,
    import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY
);

export const updateStreak = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return null;

    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()).toISOString();

    const metadata = user.user_metadata || {};
    const lastActivity = metadata.last_activity_date;
    let currentStreak = metadata.streak_count || 0;

    if (!lastActivity) {
        // First activity ever
        currentStreak = 1;
    } else {
        const lastDate = new Date(lastActivity);
        const diffTime = Math.abs(now.getTime() - lastDate.getTime());
        const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays === 1) {
            // Consecutive day
            currentStreak += 1;
        } else if (diffDays > 1) {
            // Streak broken
            currentStreak = 1;
        } else {
            // Already active today, don't update
            return currentStreak;
        }
    }

    const { data, error } = await supabase.auth.updateUser({
        data: {
            ...metadata,
            streak_count: currentStreak,
            last_activity_date: today
        }
    });

    if (error) {
        console.error('Error updating streak:', error);
        return metadata.streak_count || 0;
    }

    return currentStreak;
};

export const getStreak = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    return user?.user_metadata?.streak_count || 0;
};
